module.exports = __webpack_public_path__ + "images/icons/flags/SE-68053730.svg";